import React, { Component } from "react";

import { withStyles } from '@mui/styles';
import styles from './index.styles';
import { withTranslation } from 'react-i18next';
import {
  Table, TableBody, TableCell, TableHead, TableRow, Tooltip, TableSortLabel, IconButton, CircularProgress, LinearProgress
} from "@mui/material";
import { Box } from "@mui/system";
import InfiniteScroll from 'react-infinite-scroll-component';
import PropTypes from "prop-types";
import { getBinSizeTranslationMap, resolveBinSizeLabel } from '../../utils/preAssignment';
import FilterAltOffOutlinedIcon from '@mui/icons-material/FilterAltOffOutlined';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import classNames from 'classnames';
import BinStatusLegend, { BIN_STATUS_LEGEND } from '../assign-prescriptions/BinStatusLegend';

const DEVICE_TYPE = {
  Assigned: '8f9c8e02-b9ee-4f29-aeea-670cef022663',
  Stocked: '4ee90c0f-d4c3-4d53-8014-d7eac4ea2894',
  Hold: '45593c2c-fc8c-4bf0-854e-e2bf759b7788',
  Deactivate: '4f666da5-bfe0-4fb5-ad77-b92103881220',
};

let FilterObj = {
  sortOrder: 'desc',
  sortColumn: 'created_on',
  tableName: ''
}

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  if (array && array.length <= 0) {
    return [];
  }
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
  return order === "desc"
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}

const PreAssignmentRecentOrdersColGroup = () => (
  <colgroup>
    <col className="recent-orders-col-status" />
    <col className="recent-orders-col-patient" />
    <col className="recent-orders-col-stock" />
    <col className="recent-orders-col-bin" />
    <col className="recent-orders-col-size" />
  </colgroup>
);
class EnhancedTableHead extends React.Component {
  createSortHandler = (property, field) => event => {
    this.props.onRequestSort(event, property, field);
  };

  render() {
    const {
      order,
      orderBy,
      sortId,
      t
    } = this.props;
    const rows = [
      { id: "name", numeric: false, disablePadding: false, label: t('Task.Patient'), field: 'name' },
      { id: "stock_code", numeric: false, disablePadding: false, label: t('Unplugged.SearchPopup.StockCode'), field: 'stock_code' },
      { id: "bin_id", numeric: false, disablePadding: false, label: t('Unplugged.BIN'), field: 'bin_id' },
      { id: "bin_size", numeric: false, disablePadding: false, label: t('Unplugged.BinSize'), field: 'bin_size' },
    ];

    return (
      <TableHead>
        <TableRow>
          <TableCell style={{ border: 'none' }} />
          {rows.map(row => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                padding={row.disablePadding ? "none" : "default"}
                sortDirection={orderBy === row.id ? order : false}
                style={{
                  textAlign: 'left',
                  verticalAlign: 'middle',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                <Tooltip
                  title={t("Global.Label.Filter.Sort")}
                  placement={"right"}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === row.field && sortId === row.id}
                    direction={order}
                    onClick={this.createSortHandler(row.id, row.field)}
                    sx={{ '& .MuiTableSortLabel-icon': { opacity: 0.4 } }}
                  >
                    {row.label}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  sortId: PropTypes.string.isRequired
};
EnhancedTableHead = withTranslation()(EnhancedTableHead);
export class PreAssignmentLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowsPerPagePending: 10,
      hasMore: true,
      BinStatus: [],
      BoxID: this.props.BoxID,
      order: "desc",
      orderBy: "created_on",
      isFiltered: false,
      status: 'All',
      isRefreshing: false
    }
  }

  componentDidMount() {
    this.getGridData(this.state.BoxID, 'All');
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.BoxID !== prevProps.BoxID) {
      this.setState({ BoxID: this.props.BoxID });
      this.getGridData(this.props.BoxID, 'All');
    }
    if (this.props.makeAPICall !== prevProps.makeAPICall && this.props.makeAPICall) {
      this.setState({ BoxID: this.props.BoxID });
      this.reloadGrid();
    }
  }

  getGridData = (boxId, status) => {
    fetch(process.env.REACT_APP_BASEURL + `pre-assignment/gridByBox/${boxId}/${status}?tableName=${FilterObj.tableName}&sortColumn=${FilterObj.sortColumn}&sortOrder=${FilterObj.sortOrder}`, {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
      },
    })
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((bins) => {
        let deactivatedBins;
        let _binStatus = JSON.parse(bins);
        if (_binStatus && _binStatus[0] && _binStatus[0].disabled_bins) {
          deactivatedBins = _binStatus[0].disabled_bins.toString().split(',');
          _binStatus = _binStatus.map(item => {
            if (deactivatedBins.includes(item.bin_id)) {
              item.type_id = DEVICE_TYPE.Deactivate
              return item;
            } else {
              return item;
            }
          })
          if (status === 'Deactivate') {
            _binStatus = _binStatus.filter(item => item.type_id === DEVICE_TYPE.Deactivate)
          } else if (status !== 'All') {
            _binStatus = _binStatus.filter(item => item.type_id !== DEVICE_TYPE.Deactivate)
          }
        }
        this.setState({ BinStatus: _binStatus, isRefreshing: false });
        if (typeof this.props.onGridRefreshSettled === 'function') {
          this.props.onGridRefreshSettled();
        }
      }).catch(() => {
        this.setState({ isRefreshing: false });
        if (typeof this.props.onGridRefreshSettled === 'function') {
          this.props.onGridRefreshSettled();
        }
      });
  }

  handleStockCodeClick = (event, item) => {
    event && event.preventDefault();
    this.props.getPrescriptionDetails(item.bin_id, item.pm_id);
  }

  getKeyByValue = (targetValue) => {
    for (const key in DEVICE_TYPE) {
      if (DEVICE_TYPE.hasOwnProperty(key) && DEVICE_TYPE[key] === targetValue) {
        return key;
      }
    }
    return ""
  }

  getColorByValue = (label) => {
    return BIN_STATUS_LEGEND.filter((ele) => ele.label === label)[0].color
  }

  formatBinSizeCell = (item, translationMap) => {
    const map = this.props.binSizeByBinId || {};
    const binId = item && item.bin_id ? String(item.bin_id).trim() : '';
    const rawSize = (item && item.bin_size) || (binId && map[binId]) || '';
    const label = resolveBinSizeLabel(rawSize);
    if (!label) {
      return '';
    }
    return translationMap[label] || label;
  }

  fetchMoreData = (type) => {
    // Use component state for BinStatus and guard against undefined
    const binStatusArray = Array.isArray(this.state.BinStatus)
      ? this.state.BinStatus
      : [];
    const _recentOrders = binStatusArray;
    if (type === 'pending') {
      let total = 0;
      total = _recentOrders.length;
      if (total > 0) {
        this.setState({ total: this.state.total + total, rowsPerPagePending: this.state.rowsPerPagePending + 10 });
      } else {
        this.setState({ hasMore: false });
      }
    }
  }

  handleStatusClick = (e, label) => {
    e && e.preventDefault();
    this.setState({ isFiltered: true, status: label });
    this.getGridData(this.state.BoxID, label)
  }

  handleRequestSort = (event, property, field) => {
    const { BoxID, status } = this.state;
    const orderBy = property;
    let order = "desc";
    if (this.state.orderBy === orderBy) {
      order = this.state.order === "asc" ? "desc" : "asc";
    } else if (this.state.order === order) {
      order = "asc";
    } else {
      order = "desc";
    }
    this.setState({ order, orderBy, sortId: property });
    FilterObj.sortOrder = order;
    FilterObj.sortColumn = field;
    FilterObj.tableName = property === 'name' ? 'customers' : '';
    this.getGridData(BoxID, status)
  };

  clearFilters = () => {
    FilterObj.sortOrder = 'desc';
    FilterObj.sortColumn = 'created_on';
    FilterObj.tableName = '';
    this.getGridData(this.state.BoxID, 'All');
    this.setState({ isFiltered: false, status: 'All' });
  }

  reloadGrid = () => {
    if (this.state.isRefreshing) {
      return;
    }
    FilterObj.sortOrder = 'desc';
    FilterObj.sortColumn = 'created_on';
    FilterObj.tableName = '';
    this.setState({ isFiltered: false, status: 'All', isRefreshing: true })
    this.props.getAvailableBinsCount(this.state.BoxID);
    this.getGridData(this.state.BoxID, 'All');
  }

  render() {
    const { t, isViewPermissionAllowed } = this.props;
    const { BinStatus, isFiltered, isRefreshing, status } = this.state;
        const _recentOrders = BinStatus.length && BinStatus;
    const isFilterDisabled = BinStatus.length ? isFiltered ? false : true : true;
    const binSizeTranslationObj = getBinSizeTranslationMap(t);
    return (
      <Box
        component='div'
        sx={{
          width: '100%',
          textAlign: 'center',
          mt: 0.5,
        }}
      >
        <div style={{ width: '100%', display: 'flex', padding: '4px 8px', lineHeight: 1.4, flexDirection: 'column' }}>
          <div>
            <div style={{ textAlign: 'center', display: 'flex', justifyContent: "space-between", alignItems: "center" }}>
              <label style={{ color: '#000', fontSize: '0.85rem', fontWeight: 500, flex: '1' }}>
                {t('Fastlan.Component.RecentOrdersTitle')}
              </label>
              <Tooltip key="reload-grid" title={t("Reload")}>
                <IconButton
                  onClick={() => this.reloadGrid()}
                  disabled={isRefreshing}
                  size="small"
                  sx={{ backgroundColor: "transparent", p: 0.5 }}
                >
                  {isRefreshing ? <CircularProgress size={16} /> : <RefreshRoundedIcon fontSize="small" />}
                </IconButton>
              </Tooltip>
              <Tooltip key="clear-filters" title={t("Report.Assign.ClearFiltersTooltip")}>
                <IconButton disabled={isFilterDisabled} onClick={() => this.clearFilters()} size="small" sx={{ backgroundColor: "transparent", p: 0.5 }}>
                  <FilterAltOffOutlinedIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </div>
            {isRefreshing && <LinearProgress sx={{ height: 2 }} />}
            <div className="recent-orders-list-shell">
              <div className="recent-orders-list-head">
                <Table size="small" className="recent-orders-table recent-orders-table-preassignment">
                  <PreAssignmentRecentOrdersColGroup />
                  <EnhancedTableHead
                    order={FilterObj.sortOrder}
                    orderBy={FilterObj.sortColumn}
                    sortId={this.state.sortId}
                    onRequestSort={this.handleRequestSort}
                  />
                </Table>
              </div>
              <div
                id="pre-assignment-orders-scroll"
                className={classNames('recent-orders-list-body', {
                  'is-empty': !_recentOrders || !_recentOrders.length,
                })}
              >
                <InfiniteScroll
                  dataLength={this.state.rowsPerPagePending}
                  next={() => this.fetchMoreData('pending')}
                  hasMore={this.state.hasMore}
                  scrollableTarget="pre-assignment-orders-scroll"
                  endMessage={
                    <p style={{ textAlign: 'center', margin: '8px 0', fontSize: '0.75rem' }}>
                      <b>{t("Console.YouHaveSeenIt")}</b>
                    </p>
                  }>
                  <Table size="small" className="recent-orders-table recent-orders-table-preassignment">
                    <PreAssignmentRecentOrdersColGroup />
                    <TableBody>
                      {_recentOrders ? stableSort(_recentOrders, getSorting(FilterObj.sortOrder, FilterObj.sortColumn)).map((item, index) => {
                        const title = item && item.type_id && this.getKeyByValue(item.type_id);
                        const bgColor = title && this.getColorByValue(title)
                        return (
                          <TableRow key={`${item.stock_code || ''}-${item.bin_id || index}`}>
                            <TableCell style={{ border: 'none' }}>
                              <Tooltip key={index} title={title}>
                                <span style={{ background: bgColor, border: '1px solid #888', borderRadius: '50%', height: '14px', width: '14px', display: 'inline-block' }} />
                              </Tooltip>
                            </TableCell>
                            <TableCell style={{ textAlign: 'left', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.name}</TableCell>
                            <TableCell style={{ textAlign: 'left', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                              {isViewPermissionAllowed ? (
                                <a href='' title="View Pick up by" onClick={(event) => this.handleStockCodeClick(event, item)}>{item.stock_code}</a>
                              ) : item.stock_code}
                            </TableCell>
                            <TableCell style={{ textAlign: 'left', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.bin_id}</TableCell>
                            <TableCell style={{ textAlign: 'left', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{this.formatBinSizeCell(item, binSizeTranslationObj)}</TableCell>
                          </TableRow>
                        )
                      }) :
                        <TableRow>
                          <TableCell style={{ borderBottom: 'none' }} />
                          <TableCell colSpan={4} className="recent-orders-empty-cell" style={{ borderBottom: 'none' }}>
                            {t("Unplugged.NoDataFound")}
                          </TableCell>
                        </TableRow>}
                    </TableBody>
                  </Table>
                </InfiniteScroll>
              </div>
            </div>
          </div>
          <BinStatusLegend
            items={BIN_STATUS_LEGEND}
            onItemClick={this.handleStatusClick}
            activeLabel={isFiltered ? status : undefined}
          />
        </div>
      </Box>
    )
  }
}

export default withStyles(styles)(withTranslation()(PreAssignmentLayout));


// WEBPACK FOOTER //
// ./src/components/unplugged-assign-prescriptions/pre-assignment-layout.js